import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import HomePage from './Components/HomePage';
import ScrollArrow from './Assets/Hooks/Scroll';


function App() {
  return (
    <div className="App">
    <HomePage/>
    <ScrollArrow/>
    </div>
  );
}

export default App;
